export { authenticateUser, RegisterUser, forgotPassword, isSessionValid, congnitoSyncHandler,
    setPasswordByCode, resetPassword, logoutUser, updateProfilePicture, updateUserAttributes } from './session.service';



// WEBPACK FOOTER //
// ./src/common/services/session.service/index.js